import PerangkatAjarCategoryIndex from 'app/ProfileRevampPage/pages/PerangkatAjar/CategoryIndex'
import { getDeviceId } from 'utils/deviceId'

export function getServerSideProps(ctx) {
  return {
    props: {
      appDeviceID: getDeviceId(ctx),
    },
  }
}

const ProfilPerangkatAjarCategoryPage = () => {
  return <PerangkatAjarCategoryIndex />
}

ProfilPerangkatAjarCategoryPage.Layout = ({ children }) => children

export default ProfilPerangkatAjarCategoryPage
